<template>
  <div class="video-page">
    <div v-if="isLoading" class="loading-spinner"></div>
    <FullMonitorGrid v-else :cameras="cameras" />
  </div>
</template>

<script>
import { fetchScreenData } from '../utils/api.js'
import FullMonitorGrid from '../components/FullMonitorGrid.vue'

export default {
  name: 'VideoPage',
  components: {
    FullMonitorGrid
  },
  data() {
    return {
      cameras: [],
      isLoading: true
    }
  },
  mounted() {
    this.loadCameraData()
  },
  watch: {
    '$route.query': {
      handler() {
        this.loadCameraData()
      }
    }
  },
  methods: {
    async loadCameraData() {
      try {
        const data = await fetchScreenData()
        this.cameras = data || []
      } catch (error) {
        console.error('获取摄像头数据失败:', error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.video-page {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0a1628;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 3px solid rgba(99, 179, 237, 0.3);
  border-top-color: #63b3ed;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>